/**
 * @classdesc Hebrew Language Pack
 * @desc This class will used to translate tokens into the Hebrew language.
 * @namespace Languages.Hebrew
 */

/**
 * @constant dictionary
 * @type {object}
 * @memberof Languages.Hebrew
 */
export const dictionary = {
	'years'   : 'שנים',
	'months'  : 'חודש',
	'days'    : 'ימים',
	'hours'   : 'שעות',
	'minutes' : 'דקות',
	'seconds' : 'שניות'
};

/**
 * @constant aliases
 * @type {array}
 * @memberof Languages.Hebrew
 */
export const aliases = ['il', 'he-il', 'hebrew'];
